import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Row, Button, FormCheck, FormControl } from "react-bootstrap";
import { Formik } from 'formik';

import { feeGroups } from '../../ducks';
import { duckify } from "utils/duckify";

import ModalComponent from '../ModalComponent';
import FeeGroupModalErrorWrapper from './FeeGroupModalErrorWrapper';

const FeeGroupModal = ({ closeModal, feeCreate, editData, feeUpdate }) => {

  const [formikErrors, setFormikErrors] = useState({});

  const initialValues = {
    name: '',
    payment_methods: []
  };

  if(editData){
    initialValues.name = editData.name;
    initialValues.payment_methods = editData.payment_methods;
  }

  const onSubmit = (values) => {
    if(editData){
      values.id = editData.id;
    }

    const dispatchFeeGroup = editData ? feeUpdate(values) : feeCreate(values);

    dispatchFeeGroup
      .then( (resp)=> {
        closeModal();
      })
      .catch( (err) => {
        setFormikErrors(err);
      });
  };

  const checkboxChecked = (cValue) => initialValues.payment_methods.includes(cValue);

  return (
    <Formik
      initialValues={ initialValues }
      onSubmit={ (values) => onSubmit(values) }
    >
      {({
        values,
        handleChange,
        handleSubmit,
      }) => {

        const buttons = [
          <Button type='submit' onClick={handleSubmit}>
            Submit
          </Button>
        ];

        return (
          <ModalComponent
            className={'fee-group-modal'}
            title={'Fee Group Details'}
            onClose={() => closeModal()}
            buttons={buttons}
          >
            <form>
              {Object.keys(formikErrors).length > 0 &&
                <FeeGroupModalErrorWrapper>
                  {formikErrors.name && <li><span className="feegroup-error-wrapper-title">Name</span> {formikErrors.name}</li>}
                  {formikErrors.payment_methods && <li><span className="feegroup-error-wrapper-title">Payment Methods</span> {formikErrors.payment_methods}</li>}
                </FeeGroupModalErrorWrapper>
              }
              <Row className={formikErrors.name ? 'error' : null}>
                <label className="col-form-label">
                  Name
                </label>
                <div className="controls">
                  <FormControl type={'text'} name={'name'} defaultValue={values.name} onChange={handleChange} />
                </div>
              </Row>
              <Row className={formikErrors.payment_methods ? 'error' : null}>
                <label className="col-form-label">
                  Payment Methods
                </label>
                <div className="controls">
                  <label className="form-check ps-0">
                    <FormCheck type={'checkbox'} name="payment_methods" defaultChecked={ checkboxChecked('credit card')} value={'credit card'} label={'Credit Card'} onChange={handleChange} />
                    <FormCheck type={'checkbox'} name="payment_methods" defaultChecked={ checkboxChecked('electronic check')} value={'electronic check'} label={'Electronic Check'} onChange={handleChange} />
                    <FormCheck type={'checkbox'} name="payment_methods" defaultChecked={ checkboxChecked('check')} value={'check'} label={'Check'} onChange={handleChange} />
                    <FormCheck type={'checkbox'} name="payment_methods" defaultChecked={ checkboxChecked('custom')} value={'custom'} label={'Custom'} onChange={handleChange} />
                  </label>
                </div>
              </Row>
              <Row>
                <label className="col-form-label">
                  Associated Checklist Item
                </label>
                <div className="controls">
                  <div className="text">
                    {(editData && editData.checklist_item) &&
                      <div>
                        <span className="red">{editData.checklist_item.name}</span>
                      </div>
                    }

                    {!(editData && editData.checklist_item) &&
                      <div>
                        <span className="red">None</span>
                        <span className="italic">- Associate one via the checklist setup page.</span>
                      </div>
                    }

                  </div>
                </div>
              </Row>
            </form>
          </ModalComponent>
        )

      }}
      
    </Formik>  
  )
};

const mapDucksToProps = () => ({});
const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  feeCreate: (feeGroupObject) => {
    return dispatch(feeGroups.actions.create(feeGroupObject))
  },
  feeUpdate: (feeGroupObject) => {
    return dispatch(feeGroups.actions.update(feeGroupObject))
  }
});

FeeGroupModal.propTypes = {
  closeModal: PropTypes.func,
  feeCreate: PropTypes.func,
  feeUpdate: PropTypes.func,
  editData: PropTypes.shape({
    name: PropTypes.string,
    payment_methods: PropTypes.array
  })
};

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(FeeGroupModal);